import { Navigate, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Lobby from "./pages/Lobby";
import MultiplayerGame from "./pages/MultiplayerGame";
import Results from "./pages/Results";
import SinglePlayerGame from "./pages/SinglePlayerGame";

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/lobby" element={<Lobby />} />
      <Route path="/play/single" element={<SinglePlayerGame />} />
      <Route path="/play/multi" element={<MultiplayerGame />} />
      <Route path="/results" element={<Results />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
